export default __webpack_public_path__ + "static/media/truck.9fb73c40.png";